import { Box, Button, Icon, IconButton, Typography } from "@mui/material";
import React, { useContext, useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import Grids from "../../components/grids";
import AddIcon from "@mui/icons-material/Add";
import AuthContext from "../../contexts/authContext";
import axiosInstance from "../../api/axios";
import toast from "react-hot-toast";
import AddArea from "../../components/modals/addarea";

const Areas = () => {
  const [openArea, setOpenArea] = useState(false);
  const { userData, setRefresh } = useContext(AuthContext);
  const columns = [
    {
      field: "id",
      headerName: "S.No",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      minWidth: 110,
      flex: 1,
    },
    {
      field: "areaName",
      headerName: "Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "left",
      minWidth: 180,
      flex: 1,
    },
    {
      field: "customers",
      headerName: "Customers",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      flex: 1,
    },
    // {
    //   field: "paymentsToday",
    //   headerName: "Payments Today",
    //   headerClassName: "super-app-theme--header",
    //   headerAlign: "center",
    //   align: "center",
    //   minWidth: 180,
    //   flex: 1,
    // },
    // {
    //   field: "paymentsMonthly",
    //   headerName: "Payments Monthly",
    //   headerClassName: "super-app-theme--header",
    //   headerAlign: "center",
    //   align: "center",
    //   minWidth: 200,
    //   flex: 1,
    // },
    {
      field: "completecount",
      headerName: "Complete Status",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      minWidth: 180,
      flex: 1,
    },
    {
      field: "pendingcount",
      headerName: "Live",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "actions",
      headerName: "Actions",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      flex: 2,
      minWidth: 150,

      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          {/* <IconButton
              sx={{
                color: "#800001",
                "&:hover": {
                  backgroundColor: "#800001",
                  color: "#fff",
                },
              }}
              // onClick={() => handleviewCustomer(params.row._id)}
            >
              <Icon>
                <VisibilityIcon />
              </Icon>
            </IconButton> */}

          <IconButton
            sx={{
              color: "#800001",
              "&:hover": {
                backgroundColor: "#800001",
                color: "#fff",
              },
            }}
            onClick={() => handleDeleteArea(params.row._id)}
          >
            <Icon>
              <DeleteIcon />
            </Icon>
          </IconButton>
        </Box>
      ),
    },
  ];
  const rows = userData?.areas
    ?.filter((sch) => sch.status !== "erased")
    .map((item, index) => {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, "0");
      const mon = String(today.getMonth() + 1).padStart(2, "0");
      const year = today.getFullYear();
      const todayFormatted = `${day}/${mon}/${year}`; // "DD/MM/YYYY"

      // only payments for *this* scheme:
      const allPayments =
        userData.payments?.filter((p) => p.schemeId?.schemeId === item._id) ||
        [];

      const paytoday = userData.custSchemes.filter(
        (p) =>
          p.customerId?.area === item._id &&
          p.paymentsId.some((pay) => pay.collectionDate === todayFormatted)
      ).length;

      // const currentDayPayments = userData.payments.filter(
      //   (ie) => ie.collectionDate === new Date().toLocaleDateString("en-GB")
      // );

      // sum of payments whose collectionDate matches todayFormatted
      // const paymentsToday = allPayments
      //   .filter((p) => p.collectionDate === todayFormatted)
      //   .reduce((sum, p) => sum + (p.amountPaid || 0), 0);

      // sum of payments whose createdAt falls in the current month
      const paymentsMonthly = allPayments
        .filter((p) => {
          const d = new Date(p.createdAt);
          return (
            d.getDate() === today.getDate() || // optional day check if you want exactly today
            (d.getMonth() === today.getMonth() && d.getFullYear() === year)
          );
        })
        .reduce((sum, p) => sum + (p.amountPaid || 0), 0);

      const relatedCustomers =
        userData.customers?.filter(
          (customer) =>
            customer.area?._id === item._id &&
            customer.status === "active" &&
            customer.scheme.some((cs) => cs.status === "active")
        ) || [];

      const completecount = userData?.customers?.filter(
        (cust) => cust.area._id === item._id && cust.status === "completed"
      ).length;

      const pendingcount = userData?.customers?.filter(
        (cust) => cust.area._id === item._id && cust.status === "active"
      ).length;

      return {
        id: index + 1,
        _id: item._id,
        areaName: item.areaName,
        area: item.area,
        customers: relatedCustomers.length,
        paymentsToday: paytoday, // now a number
        paymentsMonthly, // now a number
        completecount,
        pendingcount,
      };
    });

  const handleDeleteArea = async (id) => {
    if (!window.confirm("Do you want to delete this area?")) return;

    const res = await axiosInstance.delete(`/area/delete/${id}`);
    if (res.status === 200) {
      toast("Area deleted successfully");
      setRefresh(true);
    } else {
      toast("Error deleting Area");
    }
  };

  return (
    <>
      <Typography
        variant="h5"
        color="#800001"
        sx={{ fontWeight: "400", textAlign: "center", mb: 2 }}
      >
        Area
      </Typography>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          mb: 2,
          justifyContent: "space-between",
          padding: "10px",
          flexWrap: "wrap",
          alignItems: "center",
        }}
      >
        <Button
          onClick={() => setOpenArea(true)}
          sx={{
            display: "flex",
            gap: 1,
            backgroundColor: "#800001",
            color: "white",
            padding: "10px",
          }}
        >
          <AddIcon sx={{ fontSize: "24px" }} />
          <Typography
            variant="p"
            sx={{
              fontSize: "14px",
              fontFamily: "sans-serif",
              fontWeight: 500,
              display: { xs: "none", sm: "block" },
            }}
          >
            Add Area
          </Typography>
        </Button>
      </Box>
      <Box sx={{ width: { xs: "95vw", sm: "81vw" } }}>
        <Grids columns={columns} rows={rows} />
      </Box>
      <AddArea setOpenArea={setOpenArea} openArea={openArea} />
    </>
  );
};

export default Areas;
